module.exports = __webpack_public_path__ + "img/logo-certi-express.c9644ccd.png";